/**
 * Created by Victor Rojo on 4/9/18.
 */
import {Component, Input} from '@angular/core';

import {SectionMap} from "../../section/Section";
import {GadgetService} from "../../gadget/Gadget.service";
import {GadgetGroupWidget} from "../../widget/Widget";
import {Widget, WidgetTypes} from "../../widget/Widget";
import {SimpleGadget} from "../../gadget/Gadget";
import {WidgetStatusChangeAware} from "../base-widget/WidgetStatusChangeAware";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";
import {SSEElement} from "../../element/Element";


@Component({
  selector: 'gadget-group',
  templateUrl: './GadgetGroup.html',
  styleUrls: ['./GadgetGroup.css']
})
export class GadgetGroupComponent extends WidgetStatusChangeAware{
  gadgets: SimpleGadget[];
  @Input()
  columns: number;
  subscriptions: any[] = [];
  elements:any = {};

  constructor(private iPlaceDataChangeService1: IPlaceDataChangeService,
              private gadgetService: GadgetService) {
    super(iPlaceDataChangeService1);

    this.subscriptions.push(this.iPlaceDataChangeService1.elementChange$.subscribe( (element:SSEElement) => {
      let gadgetElement = this.elements[element.id];
      if ( gadgetElement ) {
        gadgetElement.name = element.name;
        gadgetElement.value = element.value;
        gadgetElement.status = element.status;
        gadgetElement.updateDate = element.updateDate;
        gadgetElement.lastStatusChange = element.lastStatusChange;
      }
    }));
  }

  get widget(): GadgetGroupWidget {
    return this._widget as GadgetGroupWidget;
  }

  @Input()
  set widget(gadgetGroupWidget: GadgetGroupWidget) {
    this._widget = gadgetGroupWidget;
    this.updateValues(gadgetGroupWidget);
  }

  private updateValues(gadgetGroupWidget: GadgetGroupWidget){
    let positions:any[] = [];
    let gadgetList:any[] = [];
    let max = Math.max.apply(Math, gadgetGroupWidget.gadgets.map(gadget => gadget.gadgetOrder));

    this.elements = {};

    gadgetGroupWidget.gadgets
      .forEach(gadget => gadget.elements.forEach(element => this.elements[element.elementId] = element));

    gadgetGroupWidget.gadgets.forEach(gadget => {
      positions[gadget.gadgetOrder] = gadget;
    });

    for (let i = 1; i <= max; i++) {
      if ( positions[i] ) {
        gadgetList.push(positions[i]);
      } else {
        gadgetList.push({gadgetOrder: i});
      }
    }
    this.gadgets = gadgetList;
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
